import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
//api
import { editFaq, getFaq } from 'api/faqs';
//components
import Title from 'components/backoffice/texts/title';
import FaqForm from 'components/backoffice/forms/faqForm';

const EditFaq = () => {
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const navigate = useNavigate();
  const [faq, setFaq] = useState({});
  const { setTitle } = useOutletContext()

  const getDetailsFaq = async () => {
    const { data, status } = await getFaq(id);
    if (status === 200) {
      setFaq(data);
    } else {
      setFaq([]);
    }
  };

  useEffect(() => {
    getDetailsFaq();
  }, []);


  useEffect(() => {
    if (faq) {
      setTitle(t('edit', { title: faq?.question }))
    }
    return () => {
      setTitle('');
    };
  }, [faq])

  const onSubmit = async (values) => {
    const order = values.order;
    delete values.order;
    const sendValues = {
      order: order.value,
      ...values,
    };
    try {
      const { status } = await editFaq(sendValues, id);
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate(-1);
      } else toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    } catch (error) {
      console.error('Error en onEdit:', error);
    }
  };

  return (
    <div>
      <Title text={t('editar')} />
      <FaqForm onSubmit={onSubmit} faq={faq} />
    </div>
  );
};

export default EditFaq;
